var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsUrl, IsUUID } from 'class-validator';
export class WebhookSubscriptionFullSizeDto {
    id;
    createdAt;
    updatedAt;
    url;
    officeLocationId;
    officeId;
    events;
    active = false;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], WebhookSubscriptionFullSizeDto.prototype, "id", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", Date)
], WebhookSubscriptionFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", Date)
], WebhookSubscriptionFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsUrl(),
    __metadata("design:type", String)
], WebhookSubscriptionFullSizeDto.prototype, "url", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], WebhookSubscriptionFullSizeDto.prototype, "officeLocationId", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], WebhookSubscriptionFullSizeDto.prototype, "officeId", void 0);
__decorate([
    Expose(),
    IsArray(),
    __metadata("design:type", Array)
], WebhookSubscriptionFullSizeDto.prototype, "events", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], WebhookSubscriptionFullSizeDto.prototype, "active", void 0);
//# sourceMappingURL=webhook-subscription.full-size.dto.js.map